import { apiGet } from "../core/request";

export type TransactionUI = {
  type_label: string;
  recipient_name: string;
  created_at_fmt: string;
};

export type Transaction = {
  id: number;
  user_id: number;
  account_id: number | null;
  amount: number;
  currency: string;
  type: string | null;
  direction: string | null;
  description: string | null;
  status: string;
  transaction_date: string | null; // ISO8601
  created_at: string | null;
  updated_at: string | null;
  related_entity_type: string;
  related_entity_id: number;
  ui: TransactionUI;
};

export type AccountsSummaryItem = {
  id: number;
  currency: string;
  summary: {
    balance: number;
    pending_out: number;
    available: number;
  };
};

export type TransactionsIndexResponse = {
  data: Transaction[];
  meta: {
    filter: string;
    search: string | null;
    from: string | null;
    to: string | null;
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
  links: {
    next_page_url: string | null;
    prev_page_url: string | null;
  };
  accounts: AccountsSummaryItem[];
};

type IndexParams = Partial<{
  page: number;
  per_page: number;
  search: string;
  filter: "all" | "incoming" | "outgoing" | "exchange" | "card" | "fee";
  from: string; // YYYY-MM-DD
  to: string;   // YYYY-MM-DD
}>;

// Small compatibility guard: works whether apiGet returns { data: ... } or raw JSON.
function unwrap<T>(res: any): T {
  return (res && typeof res === "object" && "data" in res && !("meta" in res) && !("accounts" in res))
    ? (res.data as T)
    : (res as T);
}

export async function apiTransactionsIndex(params: IndexParams = {}): Promise<TransactionsIndexResponse> {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && String(v).length > 0) query.set(k, String(v));
  });

  const res = await apiGet(`/xapi/transactions?${query.toString()}`);
  return unwrap<TransactionsIndexResponse>(res);
}
